import { tracker } from './'

const valueBySelector = selector =>
  document.querySelector(`[${selector}]`).getAttribute(selector)

export const buildEventPurchase = () => {
  const value = parseFloat(valueBySelector('data-original-price'))
  const shipping = parseFloat(valueBySelector('data-order-shipping-cost'))
  const itemsInDOM = document.querySelectorAll('[data-product-layer]')
  const items = []

  itemsInDOM.forEach(item => {
    items.push({
      currency: 'BLR',
      item_id: item.getAttribute('data-product-id'),
      item_name: item.getAttribute('data-item-name'),
      price: parseFloat(item.getAttribute('data-price')),
      quantity: item.getAttribute('data-product-quantity')
    })
  })

  tracker.purchase({
    value,
    items,
    shipping
  })
}
